import { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import axios from "../../utils/axiosInstance";
import FanClutchC5 from "./FanClutchC5";

const FAN_CLUTCH_REGISTERS = ["41800","41801","41802","41803","41804","41805","41806"];

export default function FanClutch({ selectedDevice }) {
  const [type, setType]               = useState("");
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading]         = useState(true);

  const unitId = selectedDevice?.id;

  useEffect(() => {
      if (!unitId) {
      setLoading(false);
      return;
    }
    const fetchType = async () => {
      try {
        setLoading(true);
        const resp = await axios.post(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
          FAN_CLUTCH_REGISTERS,
        );
        setType(resp.data.data?.type || "");
        setInitialData(resp.data.data);
      } catch (err) {
        console.error("Fan clutch fetch error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchType();
  }, [unitId]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 200,
          bgcolor: "#1e293b",
        }}
      >
        <CircularProgress size={50} />
      </Box>
    );
  }

  if (type === "C5" || type === "C5E" || type === "C5EPLG") {
    return <FanClutchC5 selectedDevice={selectedDevice} initialData={initialData} />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200,
        bgcolor: "#1e293b",
        borderRadius: 1,
      }}
    >
      <Typography sx={{ color: "#94a3b8", fontSize: 15 }}>
        Fan Clutch is not available for this controller.
      </Typography>
    </Box>
  );
}